import { ApiService } from '../../../config/apiServices';
import { UDDYAMAAN_APPLICATION_ADMIN_URL } from '../../../config/adminUrlConfig';

export const getUddyamaanApplications = (page = 1, search = '', status = '', programId = '', perPage = 10, schemeType = '') => {
  let url = `${UDDYAMAAN_APPLICATION_ADMIN_URL}?page=${page}&per_page=${perPage}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (status) url += `&status=${encodeURIComponent(status)}`;
  if (programId) url += `&program_id=${programId}`;
  if (schemeType) url += `&scheme_type=${encodeURIComponent(schemeType)}`;
  return ApiService.get(url);
};

export const getUddyamaanApplicationById = (id) =>
  ApiService.get(`${UDDYAMAAN_APPLICATION_ADMIN_URL}/${id}`);

export const updateUddyamaanApplicationStatus = (id, status, admin_remark = '') =>
  ApiService.post(`${UDDYAMAAN_APPLICATION_ADMIN_URL}/${id}/status`, { status, admin_remark });

export const getUddyamaanStats = (schemeType = '') => {
  let url = `${UDDYAMAAN_APPLICATION_ADMIN_URL}/stats`;
  if (schemeType) url += `?scheme_type=${encodeURIComponent(schemeType)}`;
  return ApiService.get(url);
};

export const getUddyamaanApplicants = (page = 1, search = '', status = '', perPage = 10, schemeType = '') => {
  let url = `${UDDYAMAAN_APPLICATION_ADMIN_URL}/applicants?page=${page}&per_page=${perPage}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (status) url += `&status=${encodeURIComponent(status)}`;
  if (schemeType) url += `&scheme_type=${encodeURIComponent(schemeType)}`;
  return ApiService.get(url);
};

export const getUddyamaanAssessments = ({ page = 1, search = '', perPage = 10, gender = '', ageRange = '', assessmentStatus = '', schemeType = '' } = {}) => {
  let url = `${UDDYAMAAN_APPLICATION_ADMIN_URL}/assessments?page=${page}&per_page=${perPage}`;
  if (search) url += `&search=${encodeURIComponent(search)}`;
  if (gender) url += `&gender=${encodeURIComponent(gender)}`;
  if (ageRange) url += `&age_range=${encodeURIComponent(ageRange)}`;
  if (assessmentStatus) url += `&assessment_status=${encodeURIComponent(assessmentStatus)}`;
  if (schemeType) url += `&scheme_type=${encodeURIComponent(schemeType)}`;
  return ApiService.get(url);
};

export const saveUddyamaanAssessment = (applicationId, data) =>
  ApiService.post(`${UDDYAMAAN_APPLICATION_ADMIN_URL}/${applicationId}/assessment`, data);

export const getUddyamaanAssessmentResult = (applicationId) =>
  ApiService.get(`${UDDYAMAAN_APPLICATION_ADMIN_URL}/${applicationId}/assessment`);

export const sendUddyamaanApplicationsForward = (applicationIds) =>
  ApiService.post(`${UDDYAMAAN_APPLICATION_ADMIN_URL}/send-forward`, { application_ids: applicationIds });

export const selectUddyamaanApplications = (applicationIds) =>
  ApiService.post(`${UDDYAMAAN_APPLICATION_ADMIN_URL}/select-applications`, { application_ids: applicationIds });

export const getUddyamaanAssessmentHistory = (applicationId) =>
  ApiService.get(`${UDDYAMAAN_APPLICATION_ADMIN_URL}/${applicationId}/assessment-history`);
